/**
 * Item icon size — Figma draws every Tab item icon at 20px (2363:3325).
 */
export const TAB_ICON_SIZE = 20;

/**
 * Resolved icon colour per (active | disabled, dark-mode). Mirrors the item
 * text colours in `Tab.variants.ts`. Only consulted on NATIVE — on web the
 * icon inherits `currentColor` from the item's CSS text colour.
 *
 * Values are the auto-inverting `secondary` tokens (verified on the dark item
 * set 2812:44313): active/disabled use secondary-800 (#262626 light →
 * #e5e5e5 dark), default uses secondary-600 (#525252 → #a1a1a1).
 */
const DEFAULT = { light: '#525252', dark: '#a1a1a1' }; // secondary-600
const ACTIVE = { light: '#262626', dark: '#e5e5e5' }; // secondary-800

export function resolveTabIconColor(
  active: boolean,
  disabled: boolean,
  isDark: boolean,
): string {
  const pair = active || disabled ? ACTIVE : DEFAULT;
  return isDark ? pair.dark : pair.light;
}
